import { GetActivoByIdDtoProps } from "api/DTOs/GetActivoByIdDto"
import {
  ErrorMessage,
  Field,
  FormikErrors,
  FormikHandlers,
  FormikState,
} from "formik"
import { TFunction } from "i18next"

interface OterDetailProps {
  errors: FormikErrors<OterDetailProps["values"]>
  handleChange: FormikHandlers["handleChange"]
  touched: FormikState<OterDetailProps["values"]>["touched"]
  values: Partial<GetActivoByIdDtoProps>
  t: TFunction
}
export const OtherDetail = ({
  errors,
  handleChange,
  touched,
  values,
  t,
}: OterDetailProps) => (
  <div className='tw-grid tw-grid-cols-6 tw-gap-4'>
    <div className='tw-col-span-6 tw-text-left tw-font-medium'>
      {t("nsAssets.tabDetails.others")}
    </div>
    <div className='tw-col-span-6 tw-text-left'>
      <label
        htmlFor='descripcion'
        className='!tw-mb-0 tw-text-left'
      >
        {t("nsAssets.tabDetails.description")}
      </label>
      <Field
        id='descripcion'
        name='descripcion'
        type='text'
        as='textarea'
        rows='3'
        className={`tw-block tw-border tw-rounded tw-w-full tw-px-2 tw-py-1 ${
          errors.descripcion && touched.descripcion
            ? "tw-border-danger"
            : "tw-border-neutral-25"
        }`}
        onChange={handleChange}
        value={values?.descripcion ?? ""}
      />
      <ErrorMessage
        name='descripcion'
        className='tw-text-danger tw-text-left'
        component='div'
      />
    </div>
    <div className='tw-col-span-2 tw-text-left'>
      <label
        htmlFor='numeroSerie'
        className='!tw-mb-0 tw-text-left'
      >
        {t("nsAssets.tabDetails.serialNumber")}
      </label>
      <Field
        id='numeroSerie'
        name='numeroSerie'
        type='text'
        className={`tw-border tw-rounded tw-h-10 tw-w-full tw-px-2 tw-py-1 ${
          errors.numeroSerie && touched.numeroSerie
            ? "tw-border-danger"
            : "tw-border-neutral-25"
        }`}
        onChange={handleChange}
        value={values?.numeroSerie ?? ""}
      />
      <ErrorMessage
        name='numeroSerie'
        className='tw-text-danger tw-text-left'
        component='div'
      />
    </div>
    <div className='tw-col-span-2 tw-text-left'>
      <label
        htmlFor='numeroInventario'
        className='!tw-mb-0 tw-text-left'
      >
        {t("nsAssets.tabDetails.inventoryNumber")}
      </label>
      <Field
        id='numeroInventario'
        name='numeroInventario'
        type='text'
        className={`tw-border tw-rounded tw-h-10 tw-w-full tw-px-2 tw-py-1 ${
          errors.numeroInventario && touched.numeroInventario
            ? "tw-border-danger"
            : "tw-border-neutral-25"
        }`}
        onChange={handleChange}
        value={values?.numeroInventario ?? ""}
      />
      <ErrorMessage
        name='numeroInventario'
        className='tw-text-danger tw-text-left'
        component='div'
      />
    </div>
    <div className='tw-col-span-2 tw-text-left'>
      <label
        htmlFor='codigoBarras'
        className='!tw-mb-0 tw-text-left'
      >
        {t("nsAssets.tabDetails.barcode")}
      </label>
      <Field
        id='codigoBarras'
        name='codigoBarras'
        type='text'
        className={`tw-border tw-rounded tw-h-10 tw-w-full tw-px-2 tw-py-1 ${
          errors.codigoBarras && touched.codigoBarras
            ? "tw-border-danger"
            : "tw-border-neutral-25"
        }`}
        onChange={handleChange}
        value={values?.codigoBarras ?? ""}
      />
      <ErrorMessage
        name='codigoBarras'
        className='tw-text-danger tw-text-left'
        component='div'
      />
    </div>
    <div className='tw-col-span-3 tw-text-left'>
      <label
        htmlFor='marca'
        className='!tw-mb-0 tw-text-left'
      >
        {t("nsAssets.tabDetails.brand")}
      </label>
      <Field
        id='marca'
        name='marca'
        type='text'
        className={`tw-border tw-rounded tw-h-10 tw-w-full tw-px-2 tw-py-1 ${
          errors.marca && touched.marca
            ? "tw-border-danger"
            : "tw-border-neutral-25"
        }`}
        onChange={handleChange}
        value={values?.marca ?? ""}
      />
      <ErrorMessage
        name='marca'
        className='tw-text-danger tw-text-left'
        component='div'
      />
    </div>
    <div className='tw-col-span-3 tw-text-left'>
      <label
        htmlFor='modelo'
        className='!tw-mb-0 tw-text-left'
      >
        {t("nsAssets.tabDetails.model")}
      </label>
      <Field
        id='modelo'
        name='modelo'
        type='text'
        className={`tw-border tw-rounded tw-h-10 tw-w-full tw-px-2 tw-py-1 ${
          errors.modelo && touched.modelo
            ? "tw-border-danger"
            : "tw-border-neutral-25"
        }`}
        onChange={handleChange}
        value={values?.modelo ?? ""}
      />
      <ErrorMessage
        name='modelo'
        className='tw-text-danger tw-text-left'
        component='div'
      />
    </div>
  </div>
)
